import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { cloneDeep, uniqueId } from 'lodash';
import { InspectionImageDto } from 'remarketing-angular-library';
import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-existing-photos-modal',
    templateUrl: './existing-photos-modal.component.html',
    styleUrls: ['./existing-photos-modal.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, ModalComponent, CommonModule]
})
export class ExistingPhotosModalComponent {
  @ViewChild(ModalComponent) defaultModal: ModalComponent;
  @Input() origninalPhotoList: InspectionImageDto[];
  @Input() maxPhotoSelection: number;
  @Output() selectedExistingImages = new EventEmitter<any>();
  currIndex: number;
  photoList: InspectionImageDto[];

  readonly id = uniqueId('existing-photo-modal-');

  //opens the existing photo modal
  show(index) {
    this.currIndex = index;
    this.photoList = cloneDeep(this.origninalPhotoList);
    this.defaultModal.show();
  }

  //close the existing photo modal
  close() {
    this.defaultModal.close();
  }

  //select photos on the modal
  selectExistingPhotos(currIndex) {
    if (this.selectedPhotos.length < this.maxPhotoSelection || (this.photoList[currIndex] as any).isExistingImage) {
      (this.photoList[currIndex] as any).isExistingImage = !(this.photoList[currIndex] as any).isExistingImage;
    }
  }

  //send selected photos to the parent component
  sendSelectedPhotos() {
    this.selectedExistingImages.emit({ photoList: this.photoList, currIndex: this.currIndex });
    this.close();
  }

  //returns the selected photos
  get selectedPhotos(): InspectionImageDto[] {
    return this.photoList.filter((photoItem: any) => {
      return photoItem.isExistingImage;
    });
  }
}
